/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { MarketplaceConfig } from '../model';
/**
 * MarketplaceConfigApi - axios parameter creator
 * @export
 */
export const MarketplaceConfigApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns config options for Marketplace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceConfigRetrieve: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v2/marketplace/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketplaceConfigApi - functional programming interface
 * @export
 */
export const MarketplaceConfigApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketplaceConfigApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Returns config options for Marketplace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async marketplaceConfigRetrieve(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MarketplaceConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.marketplaceConfigRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MarketplaceConfigApi - factory interface
 * @export
 */
export const MarketplaceConfigApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketplaceConfigApiFp(configuration)
    return {
        /**
         * 
         * @summary Returns config options for Marketplace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        marketplaceConfigRetrieve(options?: any): AxiosPromise<MarketplaceConfig> {
            return localVarFp.marketplaceConfigRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarketplaceConfigApi - object-oriented interface
 * @export
 * @class MarketplaceConfigApi
 * @extends {BaseAPI}
 */
export class MarketplaceConfigApi extends BaseAPI {
    /**
     * 
     * @summary Returns config options for Marketplace
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketplaceConfigApi
     */
    public marketplaceConfigRetrieve(options?: any) {
        return MarketplaceConfigApiFp(this.configuration).marketplaceConfigRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}
